import { RevisionMetadata } from "../RevisionItem";
import { asortymentResource, Asortyment } from "./Asortyment";
import { komponentResource, Komponent } from "./Komponent";
import { produktResource, Produkt } from "./Produkt";
import { recepturaResource, Receptura } from "./Receptura";
import { wyrobResource, Wyrob } from "./Wyrob";
import { productListResource, ProductList } from "./ProductList";
import { ProductionRecipe, productionRecipeResource } from "./ProductionRecipe";

export const revisionMetadata: { [name: string]: RevisionMetadata } = {
  asortyment: {
    resource: asortymentResource,
    constructor: Asortyment,
  },
  komponent: {
    resource: komponentResource,
    constructor: Komponent,
  },
  produkt: {
    resource: produktResource,
    constructor: Produkt,
  },
  receptura: {
    resource: recepturaResource,
    constructor: Receptura,
  },
  productionRecipe: {
    resource: productionRecipeResource,
    constructor: ProductionRecipe,
  },
  wyrob: {
    resource: wyrobResource,
    constructor: Wyrob,
  },
  productList: {
    resource: productListResource,
    constructor: ProductList,
  },
};
